export default function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}


//////////////////
// WEBPACK FOOTER
// ./~/rrc/es/helpers/getDisplayName.js
// module id = 303
// module chunks = 0